import { useChatsData } from "@/data/use-chats-data";
import { useGroupUuid } from "@/hooks/use-group-uuid";
import { useKitUuid } from "@/hooks/use-kit-uuid";
import { useMemo } from "react";
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
} from "../ui/alert-dialog";
import { Button } from "../ui/button";
import { useAssistContext } from "./AssistContext";

type DeleteChatDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDelete: () => void;
};

export const DeleteChatDialog = ({
  open,
  onOpenChange,
  onDelete,
}: DeleteChatDialogProps) => {
  const groupUuid = useGroupUuid();
  const kitUuid = useKitUuid();
  const { chats, deleteChat } = useChatsData(groupUuid, kitUuid);
  const { activeChatUuid, setActiveChatUuid } = useAssistContext();
  const chat = useMemo(() => {
    return chats.find((c) => c.uuid === activeChatUuid);
  }, [chats, activeChatUuid]);

  const handleClick = async () => {
    if (!activeChatUuid) return;
    await deleteChat(activeChatUuid);
    onOpenChange(false);
    setActiveChatUuid(null);
    onDelete();
  };

  if (!activeChatUuid) {
    return null;
  }

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>Delete Chat</AlertDialogHeader>
        <p>Are you sure you want to delete chat "{chat?.name}"?</p>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <Button variant="destructive" size="sm" onClick={handleClick}>
            Delete
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
